import firebase from "firebase/compat/app"
import "firebase/compat/analytics"
import "firebase/compat/auth"
import "firebase/compat/firestore"
import "firebase/compat/database"
import { getStorage } from "firebase/storage"

const firebaseConfig = {
  apiKey: "AIzaSyB1kdrxwC9OVusE-ClwofXL8_A81flRt5U",
  authDomain: "khrrc-cmat.firebaseapp.com",
  projectId: "khrrc-cmat",
  storageBucket: "khrrc-cmat.appspot.com",
  messagingSenderId: "36899962948",
  appId: "1:36899962948:web:f53b09d4a3a25bb58bfc11",
  measurementId: "G-WC8RH4Z32H",
  databaseURL:
    "https://khrrc-cmat-default-rtdb.asia-southeast1.firebasedatabase.app/",
}

export const firebaseApp = firebase.initializeApp(firebaseConfig)

export const auth = firebase.auth()
export const fstorage = getStorage(firebaseApp)
